(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thornvella-article-ad"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      document.querySelectorAll('[data-thornvella-article-ads]').forEach((mount) => {
        if (mount.dataset.initialized === 'true') return;
        const article = mount.closest('article');
        const body = article?.querySelector('[data-thornvella-article-body]');
        const template = mount.querySelector('template');
        if (!body || !template) return;
        mount.dataset.initialized = 'true';
        if (mount.dataset.enableInline === 'false') return;
        const spacing = Math.max(2, Math.min(3, Number(mount.dataset.paragraphSpacing) || 3));
        const paragraphs = Array.from(body.querySelectorAll('p')).filter((paragraph) => {
          if (paragraph.closest('aside,nav,figure,table,form,details,[data-no-ads],[data-thornvella-launch-products],[data-thornvella-launch-related]')) return false;
          const text = paragraph.textContent.trim();
          const links = Array.from(paragraph.querySelectorAll('a')).reduce((total, link) => total + link.textContent.trim().length, 0);
          return text.length >= 35 && links / text.length < 0.6;
        });
        const selected = new Set();
        paragraphs.forEach((paragraph, index) => {
          if ((index + 1) % spacing !== 0 || index >= paragraphs.length - 1) return;
          let boundary = paragraph;
          const listItem = paragraph.closest('li');
          if (listItem) boundary = listItem;
          while (boundary.nextElementSibling?.matches('figure')) boundary = boundary.nextElementSibling;
          if (selected.has(boundary)) return;
          selected.add(boundary);
          const ad = template.content.firstElementChild.cloneNode(true);
          ad.dataset.thornvellaPlacement = String(selected.size);
          ad.dataset.afterParagraph = String(index + 1);
          if (boundary.parentElement.matches('ol,ul')) {
            const item = document.createElement('li');
            item.className = 'thornvella-ad-list-item';
            item.setAttribute('role', 'presentation');
            item.append(ad);
            boundary.after(item);
          } else {
            boundary.after(ad);
          }
        });
      });
      const placements = Array.from(document.querySelectorAll('[data-thornvella-ad-space]')).filter((element) => element.dataset.adPreview !== 'true' && !element.dataset.requested);
      const preview = Boolean(window.Shopify?.designMode || document.querySelector('iframe[src*="preview-bar"]')) || new URLSearchParams(window.location.search).get('tv_ad_preview') === '1';
      if (preview) return;
      const request = (element) => {
        const ad = element.querySelector('ins.adsbygoogle');
        if (!ad || !/^\d+$/.test(ad.dataset.adSlot || '') || element.getBoundingClientRect().width < 160 || element.dataset.requested) return;
        element.dataset.requested = 'true';
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          request(entry.target);
          observer.unobserve(entry.target);
        }), { rootMargin: '400px 0px' });
        placements.forEach((element) => observer.observe(element));
      } else {
        placements.forEach(request);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
